import { PlusOutlined } from "@ant-design/icons";
import { Modal, Tooltip } from "antd";
import { FC, useState } from "react";
import DetailsInfoes from "./DetailsInfoes";
import { data } from "@remix-run/router/dist/utils";

interface AddStatusOnSvgProps {
  id: string;
  tooltipTitle: string;
  data: any;
  setData: any;
}

const AddStatusOnSvg: FC<AddStatusOnSvgProps> = (props) => {
  const [isShowChangedStatusModal, setIsShowChangedStatusModal] =
    useState(false);
  return (
    <>
      <div
        className={`!w-[15px] !h-[15px] !bg-white !flex items-center justify-center !rounded-xl`}
      >
        <Tooltip title={props.tooltipTitle}>
          <PlusOutlined
            onClick={() => {
              setIsShowChangedStatusModal(true);
            }}
            className="!text-indigo-500 !text-[11px] "
          />
        </Tooltip>
        <Modal
          title=""
          open={isShowChangedStatusModal}
          onCancel={() => {
            setIsShowChangedStatusModal(false);
          }}
          footer={false}
        >
          <DetailsInfoes
            data={props.data}
            setData={props.setData}
            id={props.id}
            title={props.tooltipTitle}
            onFinish={()=>{setIsShowChangedStatusModal(false)}}
          />
        </Modal>
      </div>
    </>
  );
};

export default AddStatusOnSvg;
